import { sessionSto } from "./sessionStorageManage";
import { addRecord } from "@/apis/addRecord.js";
import { formate } from "./publicFun.js";

const recordPageList = [
  "index",
  "application",
  "products",
  "productInfo",
  "enterpriseNews",
  "aboutUS",
  "mobile_index",
  "mobile_application",
  "mobile_productsNo",
  "mobile_productInfo",
  "mobile_enterpriseNews",
  "mobile_aboutUS"
];

export function behaviorStart(to, from) {
  if (to.redirectedFrom && to.redirectedFrom === "/") {
    return;
  }
  // 进入前往recordPageList指定的页面
  var flag1 = false;
  for (var i in recordPageList) {
    if (recordPageList[i] === to.name) {
      flag1 = true;
      break;
    }
  }

  var data = null;

  if (flag1) {
    // 路由至列表页内
    let startTimeObj = new Date();
    let timeStr = formate(startTimeObj.getTime());
    let beginTime = "";
    let stoBeginTime = sessionSto.$selectSession("beginTime");
    if (stoBeginTime) {
      beginTime = sessionSto.$selectSession("beginTime");
    } else {
      beginTime = timeStr;
    }
    sessionSto.$insertSessionStorage("beginTime", timeStr);
    let model = getModel(to);
    data = {
      moNo: model.moNo,
      position: getPosition(to),
      moduleEn: model.moduleEn,
      moduleName: model.moduleName,
      itemNo: getItemNo(to),
      site: "zb",
      beginTime: beginTime,
      deviceType: 0
    };
  }

  // 是否离开指定的页面
  var flag2 = false;
  for (var i in recordPageList) {
    if (recordPageList[i] === from.name) {
      flag2 = true;
      break;
    }
  }

  if (flag2) {
    if (!data) {
      data = {};
    }
    let model = getModel(from);
    data.beginMoNo = model.moNo;
    data.beginItemNo = getItemNo(from);
  }
  if (flag1) {
    // if (!data.position) {
    //   return;
    // }
    addRecord(data);
  }
}

// 获取模块 英文/中文 名称
function getModel(fromPage) {
  switch (fromPage.name) {
    case "index":
      return { moNo: "mo0001", moduleEn: "index", moduleName: "首页 " };
    case "products":
      return {
        moNo: getMoNo(fromPage.params.no),
        moduleEn: `products/${fromPage.params.no}`,
        moduleName: `${fromPage.params.no}`
      };
    case "mobile_index":
      return { moNo: "mo0001", moduleEn: "index", moduleName: "首页 " };
    case "mobile_productsNo":
      return {
        moNo: getMoNo(fromPage.params.no),
        moduleEn: `products/${fromPage.params.no}`,
        moduleName: `${fromPage.params.no}`
      };
    // case "Mobile_shopingMallIndex":
    //   return { moNo: "mo0001", moduleEn: "index", moduleName: "首页 " };
    // case "Mobile_goodsTypes":
    //   return {
    //     moNo: getMoNo(fromPage.params.no),
    //     moduleEn: `allProduct/${getProductType(fromPage)}`,
    //     moduleName: `${getProductType(fromPage)}`
    //   };
    // case "afterSaleService":
    //   return { moNo: "mo0012", moduleEn: "aftersale", moduleName: "售后服务 " };
    // case "Mobile_afterAndGuidance":
    //   return { moNo: "mo0012", moduleEn: "aftersale", moduleName: "售后服务 " };
    // case "Mobile_merchantsJoin":
    //   return {
    //     moNo: "mo0013",
    //     moduleEn: "merchantsJoin",
    //     moduleName: "招商加盟  "
    //   };
    // case "merchantsJoin":
    //   return {
    //     moNo: "mo0013",
    //     moduleEn: "merchantsJoin",
    //     moduleName: "招商加盟  "
    //   };
    // case "brandStroy":
    //   return {
    //     moNo: "mo0014",
    //     moduleEn: "brandStroy",
    //     moduleName: "品牌故事  "
    //   };
    default:
      return { moduleEn: "", moduleName: "" };
  }
}

function getMoNo(no) {
  switch (no) {
    case "CL1000543":
      return "mo0002";
    case "CL1000547":
      return "mo0003";
    case "CL1000553":
      return "mo0004";
    case "CL1000555":
      return "mo0005";
    case "CL1000557":
      return "mo0006";
    // case "CL1000153":
    //   return "mo0007";
    // case "CL1000157":
    //   return "mo0008";
    // case "CL1000159":
    //   return "mo0009";
    // case "CL1000168":
    //   return "mo0010";
    // case "CL1000174":
    //   return "mo0011";
    // case "CL1000192":
    //   return "mo0015";
    // case "CL1000190":
    //   return "mo0016";
    case "NaN":
      return "mo0002";
    default:
      return "";
  }
}

// 获取分类名称
function getProductType(fromPage) {
  let res = "";
  let no = fromPage.params.no;
  let list = sessionSto.$selectSession("GoodsCategory");
  if (list) {
    list = JSON.parse(list);
  }
  if (no == "NaN") {
    return list[0].name;
  }
  for (var i in list) {
    if (list[i].no === no) {
      res = list[i].name;
      break;
    }
  }
  return res;
}

// 返回类型
function getPosition(fromPage) {
  switch (fromPage.name) {
    case "products":
      return 1;
    case "mobile_products":
      return 1;
    case "productInfo":
      return 3;
    case "mobile_productInfo":
      return 3;
    default:
      return 0;
  }
}

// 返回参数
function getItemNo(fromPage) {
  switch (fromPage.name) {
    // case 'allProduct':
    //   return fromPage.params.no
    // case 'Mobile_goodsTypes':
    //   return fromPage.params.no == 'NaN'?'CL1000137':fromPage.params.no
    case "productInfo":
      return fromPage.params.goodsNo;
    case "mobile_productInfo":
      return fromPage.params.goodsNo;
    default:
      return "";
  }
}



// WEBPACK FOOTER //
// ./src/util/behavior.js